'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _QuizSignAndVariationsTable = require('./QuizSignAndVariationsTable.scss');

var _QuizSignAndVariationsTable2 = _interopRequireDefault(_QuizSignAndVariationsTable);

var _asc = require('./asc.png');

var _asc2 = _interopRequireDefault(_asc);

var _desc = require('./desc.png');

var _desc2 = _interopRequireDefault(_desc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypes = React.PropTypes,
    Component = React.Component;
var QuizSignAndVariationsTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuizSignAndVariationsTable, _Component);

  function QuizSignAndVariationsTable(props) {
    (0, _classCallCheck3.default)(this, QuizSignAndVariationsTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuizSignAndVariationsTable.__proto__ || (0, _getPrototypeOf2.default)(QuizSignAndVariationsTable)).call(this, props));

    _this.generateStyle = function (currentIndex, row) {
      var columns = row.columns,
          values = row.values;

      var column = columns[currentIndex];
      var startIndex = currentIndex;
      var endIndex = currentIndex;

      while (columns[startIndex - 1] === column && (0, _typeof3.default)(values[startIndex]) !== 'object') {
        startIndex -= 1;
      }

      while (columns[endIndex + 1] === column && (0, _typeof3.default)(values[endIndex + 1]) !== 'object') {
        endIndex += 1;
      }

      var sequenceLength = endIndex + 1 - startIndex;
      var positionInSequence = currentIndex + 1 - startIndex;

      if (sequenceLength > 1) {
        var partPercent = 92 / (sequenceLength - 1);
        var partCalculated = (positionInSequence - 1) * partPercent;
        return {
          arrowStyle: {
            transform: 'scaleY(' + 1 / sequenceLength + ')',
            transformOrigin: '50% ' + (column === '+' ? 92 - partCalculated : partCalculated) + '%'
          }
        };
      }

      return {};
    };

    _this.toggleSignOrVariation = function (rowIndex, columnIndex) {
      var answer = _this.props.answer;
      var columns = answer.rows[rowIndex].columns;


      answer.rows[rowIndex].columns[columnIndex] = columns[columnIndex] === '+' ? '-' : '+';

      _this.props.onChange(answer);
    };

    _this.toggleSignValue = function (rowIndex, columnIndex) {
      var answer = _this.props.answer;

      var possibleValues = ['0', '', null];
      var values = answer.rows[rowIndex].values;


      var possibleValuesIndex = possibleValues.indexOf(values[columnIndex]);
      possibleValuesIndex += 1;

      if (possibleValuesIndex > possibleValues.length - 1) {
        possibleValuesIndex = 0;
      }

      answer.rows[rowIndex].values[columnIndex] = possibleValues[possibleValuesIndex];

      _this.props.onChange(answer);
    };

    _this.toggleForbiddenValue = function (rowIndex, columnIndex) {
      var answer = _this.props.answer;
      var values = answer.rows[rowIndex].values;


      answer.rows[rowIndex].values[columnIndex] = (0, _typeof3.default)(values[columnIndex]) === 'object' ? '?' : ['?', '?'];

      _this.props.onChange(answer);
    };

    _this.deleteLastColumn = function () {
      var answer = _this.props.answer;


      answer.intervals -= 1;
      answer.var.values.pop();
      answer.rows.forEach(function (row) {
        row.columns.pop();
        row.values.pop();
      });

      _this.props.onChange(answer);
    };

    _this.addColumn = function () {
      var answer = _this.props.answer;

      answer.intervals += 1;
      answer.var.values.push('?');
      answer.rows.forEach(function (row) {
        row.columns.push('+');
        row.values.push(row.type === 'sign' ? '0' : '?');
      });

      _this.props.onChange(answer);
    };

    _this.editValue = function (rowIndex, valueIndex) {
      var subIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var answer = _this.props.answer;


      if (rowIndex === -1) {
        var prevValue = answer.var.values[valueIndex];
        var newValue = prompt('Saisir au format LaTeX', prevValue);

        if (newValue !== null) {
          answer.var.values[valueIndex] = newValue.trim().length === 0 ? '?' : newValue;
        }
      } else {
        if (subIndex === -1) {
          var _prevValue = answer.rows[rowIndex].values[valueIndex];
          var _newValue = prompt('Saisir au format LaTeX', _prevValue);

          if (_newValue !== null) {
            answer.rows[rowIndex].values[valueIndex] = _newValue.trim().length === 0 ? '?' : _newValue;
          }
        } else {
          var _prevValue2 = answer.rows[rowIndex].values[valueIndex][subIndex];
          var _newValue2 = prompt('Saisir au format LaTeX', _prevValue2);

          if (_newValue2 !== null) {
            answer.rows[rowIndex].values[valueIndex][subIndex] = _newValue2.trim().length === 0 ? '?' : _newValue2;
          }
        }
      }

      _this.props.onChange(answer);
    };

    _this.editHeader = function (rowIndex) {
      var answer = _this.props.answer;


      if (rowIndex === -1) {
        var prevValue = answer.var.header;
        var newValue = prompt('Saisir au format LaTeX', prevValue);
        if (newValue !== null) {
          answer.var.header = newValue;
        }
      } else {
        var _prevValue3 = answer.rows[rowIndex].header;
        var _newValue3 = prompt('Saisir au format LaTeX', _prevValue3);
        if (_newValue3 !== null) {
          answer.rows[rowIndex].header = _newValue3;
        }
      }

      _this.props.onChange(answer);
    };

    _this.deleteRow = function (index) {
      var answer = _this.props.answer;


      answer.rows.splice(index, 1);

      _this.props.onChange(answer);
    };

    _this.addSignRow = function () {
      var answer = _this.props.answer;


      answer.rows.unshift({
        header: "f'(x)",
        type: 'sign',
        columns: [].concat((0, _toConsumableArray3.default)(Array(answer.intervals))).fill('+'),
        values: [].concat((0, _toConsumableArray3.default)(Array(answer.intervals - 1))).fill('0')
      });

      _this.props.onChange(answer);
    };

    _this.addVariationsRow = function () {
      var answer = _this.props.answer;


      answer.rows.push({
        header: 'f(x)',
        type: 'var',
        columns: [].concat((0, _toConsumableArray3.default)(Array(answer.intervals))).fill('+'),
        values: [].concat((0, _toConsumableArray3.default)(Array(answer.intervals + 1))).fill('?')
      });

      _this.props.onChange(answer);
    };

    return _this;
  }

  (0, _createClass3.default)(QuizSignAndVariationsTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          answer = _props.answer,
          innerHTML = _props.innerHTML;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'table',
          { className: _QuizSignAndVariationsTable2.default.signTable },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                React.createElement(
                  'span',
                  {
                    className: _QuizSignAndVariationsTable2.default.editable,
                    onClick: function onClick() {
                      return _this2.editHeader(-1);
                    }
                  },
                  innerHTML(answer.var.header)
                )
              ),
              [].concat((0, _toConsumableArray3.default)(Array(answer.intervals * 2))).map(function (element, index) {
                var columnIndex = index > 0 ? index / 2 : index;
                if ((index + 1) % 2 === 0) {
                  return React.createElement(
                    'td',
                    { key: index },
                    '\xA0'
                  );
                }

                return React.createElement(
                  'td',
                  { key: index },
                  React.createElement(
                    'span',
                    {
                      className: _QuizSignAndVariationsTable2.default.editable,
                      onClick: function onClick() {
                        return _this2.editValue(-1, columnIndex);
                      }
                    },
                    innerHTML(answer.var.values[columnIndex])
                  )
                );
              }),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'span',
                  {
                    className: _QuizSignAndVariationsTable2.default.editable,
                    onClick: function onClick() {
                      return _this2.editValue(-1, answer.intervals);
                    }
                  },
                  innerHTML(answer.var.values[answer.intervals])
                )
              ),
              React.createElement(
                'td',
                null,
                answer.intervals > 1 && React.createElement(
                  'button',
                  { onClick: this.deleteLastColumn },
                  '-'
                ),
                React.createElement(
                  'button',
                  { onClick: this.addColumn },
                  '+'
                )
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            answer.rows.map(function (row, rowIndex) {
              if (row.type === 'sign') {
                return React.createElement(
                  'tr',
                  { key: rowIndex, className: _QuizSignAndVariationsTable2.default.signRow },
                  React.createElement(
                    'th',
                    null,
                    'signe de',
                    React.createElement('br', null),
                    React.createElement(
                      'span',
                      { className: _QuizSignAndVariationsTable2.default.editable, onClick: function onClick() {
                          return _this2.editHeader(rowIndex);
                        } },
                      innerHTML(row.header)
                    )
                  ),
                  React.createElement(
                    'td',
                    null,
                    '\xA0'
                  ),
                  [].concat((0, _toConsumableArray3.default)(Array(answer.intervals * 2))).map(function (element, index) {
                    if (index < answer.intervals * 2 - 1) {
                      var columnIndex = index > 0 ? index / 2 : index;
                      if ((index + 1) % 2 === 0) {
                        columnIndex -= 0.5;
                        return React.createElement(
                          'td',
                          {
                            key: index,
                            className: _QuizSignAndVariationsTable2.default.editable + ' ' + _QuizSignAndVariationsTable2.default.signValue + ' ' + (row.values[columnIndex] === null ? _QuizSignAndVariationsTable2.default.forbiddenSignValue : ''),
                            onClick: function onClick() {
                              return _this2.toggleSignValue(rowIndex, columnIndex);
                            } },
                          row.values[columnIndex] ? innerHTML(row.values[columnIndex]) : ''
                        );
                      }

                      return React.createElement(
                        'td',
                        {
                          key: index,
                          className: _QuizSignAndVariationsTable2.default.editable + ' ' + _QuizSignAndVariationsTable2.default.signColumn,
                          onClick: function onClick() {
                            return _this2.toggleSignOrVariation(rowIndex, columnIndex);
                          } },
                        innerHTML(row.columns[columnIndex])
                      );
                    }
                  }),
                  React.createElement(
                    'td',
                    null,
                    '\xA0'
                  ),
                  React.createElement(
                    'td',
                    null,
                    React.createElement(
                      'span',
                      {
                        className: _QuizSignAndVariationsTable2.default.editable,
                        onClick: function onClick() {
                          return _this2.deleteRow(rowIndex);
                        }
                      },
                      '\u274C'
                    )
                  )
                );
              }

              return React.createElement(
                'tr',
                { key: rowIndex, className: _QuizSignAndVariationsTable2.default.signRow },
                React.createElement(
                  'th',
                  null,
                  'variations de',
                  React.createElement('br', null),
                  React.createElement(
                    'span',
                    { className: _QuizSignAndVariationsTable2.default.editable, onClick: function onClick() {
                        return _this2.editHeader(rowIndex);
                      } },
                    innerHTML(row.header)
                  )
                ),
                React.createElement(
                  'td',
                  { style: {
                      verticalAlign: row.columns[0] === '+' ? 'bottom' : 'top'
                    } },
                  React.createElement(
                    'span',
                    {
                      className: _QuizSignAndVariationsTable2.default.editable,
                      onClick: function onClick() {
                        return _this2.editValue(rowIndex, 0);
                      }
                    },
                    innerHTML(row.values[0])
                  )
                ),
                [].concat((0, _toConsumableArray3.default)(Array(answer.intervals * 2))).map(function (element, index) {
                  if (index < answer.intervals * 2 - 1) {
                    var columnIndex = index > 0 ? index / 2 : index;
                    if ((index + 1) % 2 === 0) {
                      columnIndex -= 0.5;
                      return React.createElement(
                        'td',
                        {
                          key: index,
                          style: {
                            verticalAlign: row.columns[columnIndex] === '+' ? 'top' : 'bottom'
                          } },
                        (0, _typeof3.default)(row.values[columnIndex + 1]) !== 'object' && React.createElement('div', {
                          className: _QuizSignAndVariationsTable2.default.forbiddenValueSwitch,
                          onClick: function onClick() {
                            return _this2.toggleForbiddenValue(rowIndex, columnIndex + 1);
                          }
                        }),
                        (0, _typeof3.default)(row.values[columnIndex + 1]) === 'object' ? React.createElement(
                          'span',
                          { style: { display: 'flex', height: '110px' } },
                          React.createElement(
                            'span',
                            {
                              className: _QuizSignAndVariationsTable2.default.editable,
                              style: {
                                alignSelf: row.columns[columnIndex] === '+' ? 'flex-start' : 'flex-end'
                              },
                              onClick: function onClick() {
                                return _this2.editValue(rowIndex, columnIndex + 1, 0);
                              }
                            },
                            innerHTML(row.values[columnIndex + 1][0])
                          ),
                          React.createElement('span', {
                            className: _QuizSignAndVariationsTable2.default.forbiddenValue,
                            onClick: function onClick() {
                              return _this2.toggleForbiddenValue(rowIndex, columnIndex + 1);
                            }
                          }),
                          React.createElement(
                            'span',
                            {
                              className: _QuizSignAndVariationsTable2.default.editable,
                              style: {
                                alignSelf: row.columns[columnIndex + 1] === '+' ? 'flex-end' : 'flex-start'
                              },
                              onClick: function onClick() {
                                return _this2.editValue(rowIndex, columnIndex + 1, 1);
                              }
                            },
                            innerHTML(row.values[columnIndex + 1][1])
                          )
                        ) : React.createElement(
                          'span',
                          {
                            className: _QuizSignAndVariationsTable2.default.editable,
                            onClick: function onClick() {
                              return _this2.editValue(rowIndex, columnIndex + 1);
                            }
                          },
                          innerHTML(row.values[columnIndex + 1])
                        )
                      );
                    }

                    return React.createElement(
                      'td',
                      {
                        key: index,
                        className: _QuizSignAndVariationsTable2.default.editable,
                        style: _this2.generateStyle(columnIndex, row).arrowStyle,
                        onClick: function onClick() {
                          return _this2.toggleSignOrVariation(rowIndex, columnIndex);
                        } },
                      React.createElement('img', {
                        src: row.columns[columnIndex] === '+' ? _asc2.default : _desc2.default
                      })
                    );
                  }
                }),
                React.createElement(
                  'td',
                  {
                    style: {
                      verticalAlign: row.columns[answer.intervals - 1] === '+' ? 'top' : 'bottom'
                    } },
                  React.createElement(
                    'span',
                    {
                      className: _QuizSignAndVariationsTable2.default.editable,
                      onClick: function onClick() {
                        return _this2.editValue(rowIndex, answer.intervals);
                      }
                    },
                    innerHTML(row.values[answer.intervals])
                  )
                ),
                React.createElement(
                  'td',
                  null,
                  React.createElement(
                    'span',
                    { className: _QuizSignAndVariationsTable2.default.editable, onClick: function onClick() {
                        return _this2.deleteRow(rowIndex);
                      } },
                    '\u274C'
                  )
                )
              );
            })
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'button',
            { onClick: this.addSignRow },
            'Ajouter une ligne de signe'
          ),
          React.createElement(
            'button',
            { onClick: this.addVariationsRow },
            'Ajouter une ligne de variations'
          )
        )
      );
    }
  }]);
  return QuizSignAndVariationsTable;
}(Component), _class.propTypes = {
  onChange: PropTypes.func.isRequired,
  answer: PropTypes.object.isRequired,
  innerHTML: PropTypes.func.isRequired,
  startEditingMCQAnswer: PropTypes.func.isRequired
}, _temp);
exports.default = QuizSignAndVariationsTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/QuizSignAndVariationsTable.js
// module id = 1181
// module chunks = 0